import React from 'react';
import cx from 'classnames';

import { FieldInputProps, TypographyStyle } from '../../types';
import { Typography } from '../../../components/Typography';

/**
 * Input Toggle component.
 */
interface IInputToggle {
  /** Passed down classname. */
  className?: string;
  /** Default value true or false */
  defaultValue?: boolean;
  /** Optional id indicator */
  id?: string;
  /** Optional disabled indicator */
  isDisabled?: boolean;
  /** Input props from react-final-form */
  input: FieldInputProps<HTMLElement>;
  /** Title for the toggle */
  title?: string;
}

interface IState {
  isActive: any;
}

export class InputToggle extends React.PureComponent<IInputToggle, IState> {
  constructor(props: IInputToggle) {
    super(props);
    const initialValue =
      typeof props.input.value === 'boolean' ? props.input.value : props.defaultValue;

    this.state = {
      isActive: initialValue || false,
    };
  }

  componentWillReceiveProps(nextProps: IInputToggle) {
    if (this.props.input.value !== nextProps.input.value) {
      this.setState({ isActive: nextProps.input.value });
    }
  }

  render() {
    const { className, id, isDisabled = false, title } = this.props;
    const { isActive } = this.state;
    const combinedToggleClass = cx({
      'panda-input-toggle': true,
      [className || '']: !!className,
    });
    const combinedCircleContainerClass = cx({
      'panda-input-toggle-circle-container': true,
      'panda-input-toggle-circle-container--active': isActive,
      'panda-input-toggle-circle-container--disabled': isDisabled,
    });
    const combinedCircleClass = cx({
      'panda-input-toggle-circle': true,
      'panda-input-toggle-circle--active': isActive,
      'panda-input-toggle-circle--disabled': isDisabled,
    });
    const combinedTitleClass = cx({
      'panda-input-title--disabled': isDisabled,
      'panda-input-toggle-text': true,
    });

    return (
      <button
        className={combinedToggleClass}
        disabled={isDisabled}
        id={id}
        onClick={this.onValueClick}
        type="button"
      >
        <div className={combinedCircleContainerClass}>
          <div className={combinedCircleClass} />
        </div>
        {!!title && (
          <Typography className={combinedTitleClass} type={TypographyStyle.P2}>
            {title}
          </Typography>
        )}
      </button>
    );
  }

  onValueClick = () => {
    const {
      input: { onChange },
    } = this.props;

    this.setState({ isActive: !this.state.isActive });
    onChange && onChange(!this.state.isActive);
  };
}
